import {useEffect} from "react";
import {sendYandexMetrikaRgsEvent} from "../analytics";

export const useMetrikaRgsInsuredScreen = (isInsuredBefore) => {
    useEffect(() => {
        if(isInsuredBefore) {
            sendYandexMetrikaRgsEvent('rgs-checkbox-view_add_rgs')
        }
    }, []);
}